import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import DefaultModal from 'components/Utils/DefaultModal';
import { useAppSelector } from 'careand-redux/store';
import { UncontrolledCollapse } from 'components/Utils/Collapse';
import CPPListElement from 'components/Patient/CPP/CPPListElement';
import Reminders from 'components/Patient/Reminders';

const DEFAULT_ARRAY = [];

const CPPRemindersPanel = ({ patient }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const patientReminders = useAppSelector((state) => state.reminders[patient.id]) || DEFAULT_ARRAY;

  const { archived, active } = useMemo(() => {
    const archived = patientReminders.filter((reminder) => !!reminder.archived);
    const active = patientReminders.filter((reminder) => !reminder.archived);
    return { archived, active };
  }, [patientReminders]);

  return (
    <div className="reminders-wrapper">
      {modalOpen && (
        <DefaultModal
          title="Reminders"
          className="modal reminders-modal animated fadeIn"
          wrap={true}
          padding={true}
          content={<Reminders user={patient} userRole="patient" />}
          isOpen={modalOpen}
          onRequestClose={() => setModalOpen(false)}
          draggable={true}
        />
      )}
      <CPPListElement
        patient={patient}
        title="Reminders"
        field="reminders"
        icon="hourglass"
        items={active}
        setActiveCPPTab={() => setModalOpen(true)}
      />
      {archived.length > 0 && (
        <UncontrolledCollapse title={`Archived Reminders (${archived.length})`}>
          <CPPListElement
            patient={patient}
            title=""
            field="reminders"
            icon=""
            items={archived}
            allowEdit={false}
          />
        </UncontrolledCollapse>
      )}
    </div>
  );
};

CPPRemindersPanel.propTypes = {
  patient: PropTypes.object,
};

export default CPPRemindersPanel;
